import { isValidElement, cloneElement, useState } from 'react';
import { IconTrendingUp } from './sidebarIcons';
import Sidebar from '../components/SidebarNext';
import { hasFunctionAccess } from '../permissionConfig';

const NAV_BASE = [
    { to: '/d2c/shopify-tracker', label: 'Shopify Tracker', icon: <IconTrendingUp />, functionKey: 'shopify_tracker' },
];

const THEME_KEY = 'd2c_theme';
const THEME_OPTIONS = [
    { key: 'normal', label: 'Light' },
    { key: 'dark',   label: 'Dark' },
];

export default function D2CLayout({ user, onLogout, children }) {
    const [theme, setTheme] = useState(() => localStorage.getItem(THEME_KEY) || 'normal');
    const changeTheme = (next) => {
        setTheme(next);
        localStorage.setItem(THEME_KEY, next);
    };

    const navItems = NAV_BASE.map(item => ({ ...item, locked: !hasFunctionAccess(user, 'd2c', item.functionKey) }));
    return (
        <div data-sbn-theme={theme === 'normal' ? undefined : theme}
             style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: theme === 'dark' ? '#141220' : '#FAF8FC' }}>
            <Sidebar navItems={navItems} sectionLabel="D2C" homeHref="/landing" user={user}
                     domainKey="d2c"
                     theme={theme} onThemeChange={changeTheme} themeOptions={THEME_OPTIONS} />
            <div id="sbn-main" className="sbn-content"
                 style={{ flex: 1, minWidth: 0, padding: '28px 32px', overflowY: 'auto', height: '100%' }}>
                {isValidElement(children) ? cloneElement(children, { theme }) : children}
            </div>
        </div>
    );
}
